import { useStore } from 'vuex'

import { EvaluationFeedbackActions } from '@/misc/types'

// The store actions behind the feedback form of the evaluations, for the popins of the suggestions.
// useStore from vuex rather than '@/store', which imports this feature's store module back.
export function useEvaluationFeedbackActions(): EvaluationFeedbackActions {
  const store = useStore()
  return {
    save: (payload) => store.dispatch('giveEvaluationFeedback', payload),
    remove: (payload) => store.dispatch('removeEvaluationFeedback', payload),
  }
}
